import { getDomain, getHostname, getSubdomain } from 'tldts';

const whiteListHosts = ['localhost', '10.0.2.2', '127.0.0.1', '0.0.0.0'];
const wildCardDomains = ['online-karte.com', 'order-up.co', 'foodamigos-shop.com', 'foodamigos.io'];

class DomainResource {
  public extractSubdomain(): string {
    if (whiteListHosts.includes(window.location.hostname)) {
      return import.meta.env.VITE_DEFAULT_LOCAL_SUBDOMAIN;
    }

    const domain = getDomain(window.location.href);

    if (!wildCardDomains.includes(domain)) {
      return;
    }

    const subdomainParts = getSubdomain(window.location.href).split('.');

    return subdomainParts[0] === 'www' ? subdomainParts[1] : subdomainParts[0];
  }

  public getDomain(): string {
    if (whiteListHosts.includes(window.location.hostname)) {
      return window.location.hostname;
    }

    const domain = getDomain(window.location.href);

    if (!wildCardDomains.includes(domain)) {
      return window.location.hostname;
    }

    return `https://${getSubdomain(window.location.href)}.${import.meta.env.VITE_BASE_DOMAIN}`;
  }

  getHostname(): string {
    const hostname = getHostname(window.location.href);

    return hostname.replace(/^www\./, '');
  }

  public isHttpsEnabled(): boolean {
    return window.location.protocol === 'https:';
  }
}

export default new DomainResource();
